import { IPaymentRequest } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { EAssets } from "@rentiohq/web-shared-next/dist/assets";
import {
  Stack,
  IconAvatar,
  MainCard,
  DataList,
  DataListItem,
  Pagination,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { PaymentRequestCard } from "../../../../components/PaymentRequestCard";

interface IProps {
  count?: number;
  pageCount: number;
  page: number;
  isLoading?: boolean;
  paymentRequests: IPaymentRequest[];
  handlePageClick: (page: number) => void;
}

export const UpcomingPaymentRequests = ({
  paymentRequests,
  count,
  pageCount,
  page,
  handlePageClick,
}: IProps) => {
  const noOpenPayment = paymentRequests.length === 0;

  const renderPaymentRequests = () => {
    if (noOpenPayment) {
      return;
    }

    return (
      <>
        <DataList>
          {paymentRequests.map(paymentRequest => (
            <DataListItem
              key={paymentRequest?.id}
              mainContent={
                <PaymentRequestCard paymentRequest={paymentRequest} />
              }
            />
          ))}
        </DataList>
        {pageCount > 1 && (
          <Stack direction="row" justifyContent="center" mt={3}>
            <Pagination
              color="primary"
              page={page}
              count={pageCount}
              onChange={(_, page) => handlePageClick(page)}
            />
          </Stack>
        )}
      </>
    );
  };

  const title = noOpenPayment
    ? getLocalizedText("tenant.payments.no_upcoming_payments")
    : `${getLocalizedText(
        "card.general_info.section.payment_orders.cta",
      )} (${count})`;

  return (
    <MainCard
      title={title}
      border={true}
      startIcon={<IconAvatar icon={EAssets.EuroIcon} />}
    >
      {renderPaymentRequests()}
    </MainCard>
  );
};
